"use client";

import { useState } from "react";
import { useRouter } from "next/navigation";

import type { TUser } from "@/types/User";
import { SellHero } from "@/components/feed/sell-hero";
import { CreationModal } from "@/components/publications/creation-flow/creation-modal";
import AuthModal from "@/components/ui/auth-modal";

/**
 * SellHeroSection — wires the landing SellHero's two CTAs to real destinations:
 *  • "Sell Now"     → the creation flow (CreationModal) when signed in, else the
 *    login dialog (AuthModal). `/chat` is the messaging inbox, not a creation entry.
 *  • "How it works" → the mission page.
 *
 * SellHero stays presentational; this container owns the modal state + auth gate.
 */
export function SellHeroSection({
  user,
  className,
}: {
  user: TUser;
  className?: string;
}) {
  const router = useRouter();
  const [creationOpen, setCreationOpen] = useState(false);
  const [authOpen, setAuthOpen] = useState(false);

  const handleSell = () => {
    if (user) {
      setCreationOpen(true);
    } else {
      setAuthOpen(true);
    }
  };

  return (
    <>
      <SellHero
        className={className}
        onSellAction={handleSell}
        onHowItWorksAction={() => router.push("/mission")}
      />
      {user ? (
        <CreationModal open={creationOpen} onOpenChangeAction={setCreationOpen} user={user} />
      ) : (
        <AuthModal isOpen={authOpen} onCloseAction={() => setAuthOpen(false)} />
      )}
    </>
  );
}
